import styled, { css } from 'styled-components';

export const UserFeebackContainer = styled.div`
  margin: 50px auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 640px) {
    display: block;
    margin: 50px 10px 0 10px;
  }
`;

export const UserFeedbackWrapper = styled.div`
  display: flex;
  wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border: 1px solid #ccc;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 2px 8px;
  border-radius: 6px;
  padding: 20px;
  background-color: #fff;

  @media (max-width: 640px) {
    display: block;
    text-align: center;
  }
`;

export const IconWrapper = styled.div<{ direction: 'ltr' | 'rtl' }>`
  ${props =>
    props.direction === 'rtl'
      ? css`
          margin-right: 15px;
        `
      : css`
          margin-left: 15px;
        `}
`;

export const PositveFeedBackWrapper = styled.div<{ direction: 'ltr' | 'rtl' }>`
  ${props =>
    props.direction === 'rtl'
      ? css`
          padding: 0 20px 0 12px;
          [class*='Iconstyle__Icon-sc'] {
            margin-right: 8px;
          }
        `
      : css`
          padding: 0 12px 0 20px;
        `}

  button {
    padding: 12px !important;
    min-width: 100px;
  }

  button: hover {
    background-color: #188900;
    border: 2px solid #188900;
  }

  @media (max-width: 640px) {
    width: 100%;
    padding: 0;
    margin-top: 12px;

    button {
      width: 100% !important;
    }
  }
`;

export const NegativeFeedBackWrapper = styled.div<{ direction: 'ltr' | 'rtl' }>`
  ${props =>
    props.direction === 'rtl'
      ? css`
          padding-right: 12px;
          [class*='Iconstyle__Icon-sc'] {
            margin-right: 8px;
          }
        `
      : css`
          padding-left: 12px;
        `}

  button {
    padding: 12px !important;
    min-width: 100px;
  }

  @media (max-width: 640px) {
    width: 100%;
    margin-top: 15px;
    padding: 0;

    button {
      width: 100% !important;
    }
  }
`;
